<ziro-loading-block [hidden]="!isLoading"></ziro-loading-block>
@if (!isLoading) {
  <div>
    @if (pageDisabled) {
      <div class="ziro-page-alert alert border-warning" data-automation="ziro-page-disabled-alert">
        <i class="{{ ziroIcons.WARNING_TRIANGLE }} text-warning fa-4x"></i>
        <div class="ms-3" [innerHTML]="'tkey;userdetail.home.services.disabled_service.label' | escapeHtml"></div>
      </div>
    }
    @if (!pageDisabled) {
      <ziro-ms-teams-audio-conferencing-form
        [entity]="msTeamsAudioConferencing"
        [fieldConfig]="fieldConfig"
        [upn]="upn"
        [tenantId]="tenantId"
      ></ziro-ms-teams-audio-conferencing-form>
    }
  </div>
}
